import React from 'react';
import logoImg from '../styles/logo/Logoverte.png'; // Adaptez le chemin selon votre structure Web
import logoImg_black from '../styles/logo/Logoverte_black.png'; // Adaptez le chemin selon votre structure Web

export default function AnimatedLogo({ height = 36, width = 160, onClick, isDark }) {
  return (
    <div 
      onClick={onClick} 
      className="animated-logo-container"
      style={{
        display: 'inline-flex',
        cursor: onClick ? 'pointer' : 'default',
      }}
    >
      <img
        src={isDark?logoImg:logoImg_black}
        alt="EVPTrading"
        style={{
          width,
          height,
          objectFit: 'contain',
        }}
      />

      <style>{`
        .animated-logo-container {
          animation: 
            fadeIn 150ms ease-out forwards,
            pulse 2400ms ease-in-out infinite 150ms;
        }

        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: scale(0.95);
          }
          to {
            opacity: 1;
            transform: scale(1);
          }
        }

        @keyframes pulse {
          0%, 100% {
            transform: scale(1);
          }
          50% {
            transform: scale(1.03);
          }
        }
      `}</style>
    </div>
  );
}